import React, { useEffect, useState } from 'react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import './AllTabs.css'
import './ChangeDisplayName.css'
import UserService from '../../Services/UserService';
import { toast } from 'react-toastify';

const ChangeDisplayName = ({ setPage }) => {
  const [name, setName] = useState('');
  const [surName, setSurName] = useState('');
  const [originalName, setOriginalName] = useState('');
  const [originalSurName, setOriginalSurName] = useState('');
  const [nameError, setNameError] = useState('');
  const [surNameError, setSurNameError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

const validateName = (value, fieldName) => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return `${fieldName} is required`;
  }

  const namePattern = /^[A-Za-z][A-Za-z\s'-]{1,49}$/;

  if (!namePattern.test(trimmedValue)) {
    return `${fieldName} can contain only letters, spaces, hyphens, and apostrophes`;
  }

  return '';
};



  const isUpdateButtonActive =
    (name !== originalName && validateName(name, 'First name') === '' ) || 
    (surName !== originalSurName && validateName(surName, 'Surname') === '' ) ;

  let userDetailsObject = {
    name: '',
    surName: ''
  };

  useEffect(() => {
    const loadUserDetails = async () => {
      try {
        const response = await UserService.getuserDetails();

        const savedName = response.data.name || '';
        const savedSurName = response.data.surName || '';

        setName(savedName);
        setSurName(savedSurName);
        setOriginalName(savedName);
        setOriginalSurName(savedSurName);
        setNameError('');
        setSurNameError('');
      } catch (error) {
        console.log('Unable to load user details:', error);
      }
    };

    loadUserDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    const newNameError = validateName(name, 'First name');
    const newSurNameError = validateName(surName, 'Surname');

    setNameError(newNameError);
    setSurNameError(newSurNameError);

    if (newNameError || newSurNameError) {
      return;
    }
    
    setIsSubmitting(true);
    
    userDetailsObject.name = name.trim();
    userDetailsObject.surName = surName.trim();

    console.log("userDetailsObject.name------>" + userDetailsObject.name);
    console.log("userDetailsObject.surName------>" + userDetailsObject.surName);

    try {
      userDetailsObject = JSON.stringify(userDetailsObject);
      const response = await UserService.changeUserDisplayName(userDetailsObject);
      
      await UserService.refereshUser();
      
      // Use simple toast without manual configuration - let global config handle it
      toast.success(response.data.message);
      
      setTimeout(() => {
        window.location.reload();
      }, 4000);
      
    } catch (error) {
      console.log(error);
      // Check if it's an APIM error - let global interceptor handle those
      if (error.response?.data?.code?.startsWith('APIM-')) {
        console.log('APIM error caught in ChangeDisplayName, letting global interceptor handle it:', error.response.data.code);
      } else {
        // Only show toast for non-APIM errors
        toast.error(error.response?.data?.message || 'An error occurred while updating display name');
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <div className="display-name-container">
        <div className="display-name-content">
          <ul className="list-unstyled change-display-name-mpc">
            <li>
              <h3>Change Display Name</h3>
            </li>
        <li>
          <div className="custom-input-wrapp">
            <FloatingLabel
              controlId="nameJU"
              label="Enter New Name"
              className="inputText"
              autoComplete="off"
            >
              <Form.Control
                type="text"
                placeholder="Name"
                value={name}
                maxLength={50}
                onChange={(event) => {
                  const value = event.target.value;
                  setName(value);
                  if( value === originalName ){
                    setNameError('');
                  } else {
                    setNameError(validateName(value, 'First name'));
                  }
                }}
              />
              <span className="input-info-label">Eg: John</span>
              <span className="required-field-op">(Required)</span>
              <span
                className="form-error error-message-show"
                style={{ visibility: nameError ? 'visible' : 'hidden' }}
              >
                {nameError || 'First name is required'}
              </span>
            </FloatingLabel>
          </div>
        </li>
        <li>
          <div className="custom-input-wrapp">
            <FloatingLabel
              controlId="surnameJU"
              label="Enter New Surname"
              className="inputText"
              autoComplete="off"
            >
              <Form.Control
                type="text"
                placeholder="Surname"
                value={surName}
                maxLength={50}
                onChange={(event) => {
                  const value = event.target.value;
                  setSurName(value);
                  if ( value === originalSurName ){
                    setSurNameError('');
                  } else {
                    setSurNameError(validateName(value, 'Surname'));
                  }
                }}
              />
              <span className="input-info-label">Eg: Smith</span>
              <span className="required-field-op">(Required)</span>
              <span
                className="form-error error-message-show"
                style={{ visibility: surNameError ? 'visible' : 'hidden' }}
              >
                {surNameError || 'Surname is required'}
              </span>
            </FloatingLabel>
          </div>
        </li>
        <li>
          <div className="apim-pop-button-w comm-button-wrap">
            <button 
              className="ui button comm-button-style primary apim-reset-pass-btn btn-disable" 
              id="updateBtn" 
              onClick={handleSubmit}
              disabled={isSubmitting || !isUpdateButtonActive}
            >
              {isSubmitting ? 'Updating...' : 'Update'}
            </button>
            <button className="ui button comm-button-style secondary custom-loader" id="loadingBtn" style={{ display: 'none' }}>
              <i className="icon-plus iconLoader" />
              Changing Name & Surname...
            </button>
            <button className="ui button comm-button-style secondary apim-pop-button-cancel" id="cancelBtn"
              onClick={() => {
                setName(originalName);
                setSurName(originalSurName);
                setNameError('');
                setSurNameError('');
                setPage('myProfile');
              }}
            >
              Cancel
            </button>
          </div>
        </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default ChangeDisplayName;